import type { ReactNode } from "react";
import { CookiesProvider as ReactCookiesProvider } from "react-cookie";

function CookiesProvider({ children }: { children: ReactNode }) {
  return (
    <ReactCookiesProvider defaultSetOptions={{ path: "/" }}>
      {children}
    </ReactCookiesProvider>
  );
}

export default CookiesProvider;
